import LastMinuteOptionTileCardLoyaltyEnabled from './LastMinuteOptionTileCardLoyaltyEnabled';

// export default config.FF_LOYALTY_ENABLED
//   ? LastMinuteOptionTileCardLoyaltyEnabled
//   : LastMinuteOptionTileCard;

/**
 * FF not required use this always
 */
export default LastMinuteOptionTileCardLoyaltyEnabled;
